// routes
import { PATH_ROOT } from '../../../routes/paths';
// components
// import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  history: getIcon('history'),
  beacon: getIcon('ic_beacon'),
  mobile: getIcon('ic_mobile'),
  group: getIcon('ic_group'),
  checklist: getIcon('ic_checklist'),
  place: getIcon('ic_place'),
  device: getIcon('ic_devices'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      //
      { title: 'dashboard', path: PATH_ROOT.general.app, icon: ICONS.dashboard },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      //
      {
        title: 'companies',
        path: PATH_ROOT.company.root,
        icon: ICONS.banking,
        children: [
          //
          { title: 'companies-list', path: PATH_ROOT.company.list },
        ],
      },
    ],
  },
];

export default navConfig;
